import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap, map } from 'rxjs/operators';
import { Outcome } from '../models/outcomes/Outcome'
import { NgForm } from '@angular/forms';

import { API_SETTINGS } from './API_SETTINGS';
import { OutcomeGroupOutcomeRelation } from '../models/outcomes/OutcomeGroupOutcomeRelation';
import { CryptoService } from '../services/crypto.service';
import { StorageService } from '../services/storageService.service';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

const apiUrl = API_SETTINGS.API_URL + 'Outcome';
const apiOutcomeGroupUrl = API_SETTINGS.API_URL + 'OutcomeGroupOutcomeRelation';

@Injectable({
  providedIn: 'root'
})
export class ApiOutcomeService {

  constructor(
    private http: HttpClient,
    public cryptoService: CryptoService,
    public storageService: StorageService
  ) { }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  // getOutcomes (): Observable<Outcome[]> {
  //   const url = apiUrl +'/GetOutcomes'
  //   return this.http.get<Outcome[]>(url).pipe();
  // }

  //outcomes
  getOutcomesWithCustomerId(customerId: number): Observable<Outcome[]> {
    const url = apiUrl + '/GetOutcomesWithCustomerId';
    return this.http.post<Outcome[]>(url, customerId, httpOptions).pipe(
      catchError(this.handleError<Outcome[]>('GetOutcomesWithCustomerId'))
    );
  }

  getOutcome(id: number): Observable<Outcome> {
    const url = `${apiUrl}/GetOutcome/${id}`;
    return this.http.get<Outcome>(url).pipe();
  }



  getOutcomesWithSceneId(id: number): Observable<Outcome[]> {
    const url = `${apiUrl}/GetOutcomesWithSceneId/${id}`;
    return this.http.get<Outcome[]>(url).pipe();
  }

  addOutcome(Outcome: Outcome): Observable<Outcome> {
    Outcome.expiryDate = new Date();
    Outcome.customerId = +this.cryptoService.decryptData(this.storageService.getItem('customerId'));
    const url = apiUrl + '/PostOutcome'
    return this.http.post<Outcome>(url, Outcome, httpOptions).pipe();
  }

  updateOutcome(id: number, Outcome: Outcome): Observable<Outcome> {
    const url = `${apiUrl}/PutOutcome/${id}`;
    return this.http.put(url, Outcome, httpOptions).pipe(
      tap((OutcomeRes: Outcome) => true ), //console.log()),
      catchError(this.handleError<Outcome>('updateOutcome'))
    )
  }

  deleteOutcome(id: number): Observable<Outcome> {
    const url = `${apiUrl}/DeleteOutcome/${id}`;
    return this.http.delete<Outcome>(url, httpOptions).pipe();
  }

  //outcome groups 
  addOutcomeToGroup(OutcomeGroupOutcomeRelation: OutcomeGroupOutcomeRelation): Observable<OutcomeGroupOutcomeRelation> {
    const url = apiOutcomeGroupUrl + '/PostOutcomeGroupOutcomeRelation';
    return this.http.post<OutcomeGroupOutcomeRelation>(url, OutcomeGroupOutcomeRelation, httpOptions).pipe(
      catchError(this.handleError<OutcomeGroupOutcomeRelation>('PostOutcomeGroupOutcomeRelation'))
    );
  }

  addOutcomesToGroup(selected: OutcomeGroupOutcomeRelation[]) {
    const url = apiOutcomeGroupUrl + '/PostOutcomeGroupOutcomeRelationArray';
    return this.http.post<OutcomeGroupOutcomeRelation>(url, selected, httpOptions).pipe(
      catchError(this.handleError<OutcomeGroupOutcomeRelation>('PostOutcomeGroupOutcomeRelationArray'))
    );
  }

  removeOutcomesOnGroup(toRemove: OutcomeGroupOutcomeRelation[]) {
    const url = apiOutcomeGroupUrl + '/RemoveSubOutcomesByOutcomeGroupId';
    return this.http.post<OutcomeGroupOutcomeRelation>(url, toRemove, httpOptions).pipe(
      catchError(this.handleError<OutcomeGroupOutcomeRelation>('RemoveSubOutcomesByOutcomeGroupId'))
    );
  }

  getSubOutcomesByOutcomeGroupId(outcomeGroupId: number): Observable<OutcomeGroupOutcomeRelation[]> {
    const url = `${apiOutcomeGroupUrl}/GetSubOutcomesInOutcomeGroup/${outcomeGroupId}`;
    return this.http.get<OutcomeGroupOutcomeRelation[]>(url).pipe();
  }

}
